import script from "./MoreActionsDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreActionsDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./MoreActionsDropdown.vue?vue&type=style&index=0&id=5f16586a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f16586a"]])

export default __exports__